export function generateFacilityLineItems(
  pricingResponse: CommonPricingResponse,
) {
  return pricingResponse.facilities__hidden.reduce(
    (items: InvoiceLineItem[], facility) => {
      if (!('paymentResponse' in facility)) {
        items.push({
          item: facility.facilityName,
          amountDueIncGst: '0',
          taxCode: '0',
          taxRate: '0',
        })

        return items
      }
      items.push({
        item: facility.facilityName,
        amountDueIncGst: facility.paymentResponse
          ? facility.price.toFixed(2)
          : '0',
        taxCode: facility.paymentResponse?.taxCode ?? '0',
        taxRate:
          facility.paymentResponse?.Permission_Tax_rate?.toFixed(2) ?? '0',
      })
      return items
    },
    [],
  )
}

export function generateApplicationFeeLineItem(
  pricingResponse: CommonPricingResponse,
) {
  return {
    item: 'Application Fee',
    amountDueIncGst: pricingResponse.applicationFee__hidden,
    taxCode: '',
    taxRate: pricingResponse.applicationFeeTaxRate__hidden,
  }
}

export function generateProductLineItems(
  pricingResponse: CommonPricingResponse,
) {
  if (!pricingResponse.products__hidden) return []

  return pricingResponse.products__hidden.reduce(
    (items: InvoiceLineItem[], product) => {
      if (product.total > 0) {
        const item =
          product.Product_Name === 'Company Extract Search'
            ? product.Product_Name
            : `${product.Product_Name} x ${product.total}`
        items.push({
          item,
          amountDueIncGst: product.pricingResponse.AmountIncGST.toString(),
          taxCode: product.pricingResponse.taxCode,
          taxRate: product.pricingResponse.Tax_rate.toString(),
        })
      }
      return items
    },
    [],
  )
}
